import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import { useCookies } from 'react-cookie';
import { GimaModel } from '../models';

export const useCallbackGima = (params: { code: string; state: string }) => {
  const [, setCookie] = useCookies();
  return useQuery({
    queryKey: ['gima', JSON.stringify(params)],
    queryFn: async () => {
      const res = await axiosGet('api/gima/authorize/', params);
      const parsed = GimaModel.parse(res);
      setCookie('access_token', parsed.access, { path: '/' });
      return parsed;
    },
    enabled: Object.values(params).every((value) => Boolean(value)),
  });
};
